import frameRouter from './frameRouter';
import { matchPath } from 'react-router';
export const routes = [
    ...frameRouter
];

/**
 * 根据path查找route
 */
export const routePathMap = new Map();
/**
 * 根据code查找route
 */
export const routeCodeMap = new Map();

setMap(routes)
function setMap(routes) {
    for (const route of routes) {
        routePathMap.set(route.path, route);
        if(route.code) {
            routeCodeMap.set(route.code, route);
        }
        if(route.routes && route.routes.length>0) {
            setMap(route.routes);
        }
    }
    routePathMap.delete("/");
}

export function getHomeRoute() {
    return routePathMap.get('/login');
};

// http://dev.dotransit.net:3000/#/LineDetail/add
export function getRouteByPath(pathName) {
    let route = routePathMap.get(pathName);
    if(route) return route;

    // eslint-disable-next-line no-unused-vars
    for (const [key, value] of routePathMap) {
        const match = matchPath(pathName, value);
        if(match) {
            return value;
        }
    }
}


// WEBPACK FOOTER //
// ./src/routers/index.js